// extracted by mini-css-extract-plugin
module.exports = {"img":"Img","isBlurred":"is-blurred","isLoaded":"is-loaded"};